import axios from 'axios';
import { URI_TARGET } from '../helpers/constans';
import { IFinderMessagePayload } from '../types/@target';

export const fetchTarget = (id: string) => {
  return axios.get(`${URI_TARGET}/${id}`);
};

export const sendFinderMessage = ({ id, ...payload }: IFinderMessagePayload) => {
  return axios.post(`${URI_TARGET}/${id}/finder-message`, payload);
};